module.exports = __webpack_public_path__ + "img/guest-access.050501c9.webp";